<template>
  <v-row no-gutters class="article-tile-row">
    <v-col cols="12">
      <v-row class="article-tiles-row">
        <v-col
          class="article-tile-segment"
          cols="12"
          sm="6"
          md="4"
          lg="4"
          v-for="(tile, index) in tiles"
          :key="index"
          v-if="index < visibleArticleCount"
        >
          <ArticleTile :tile="tile" @buttonClicked="handleClick"></ArticleTile>
        </v-col>
      </v-row>
    </v-col>
    <div class="actions-container">
      <span
        class="view-all-articles"
        @click="viewAllArticles"
        v-if="visibleArticleCount === 3"
        >View All Articles</span
      >
      <span class="view-all-articles" @click="viewAllArticles" v-else
        >Hide Additional Articles</span
      >
    </div>
  </v-row>
</template>

<script>
import ArticleTile from "./ArticleTile.vue";

export default {
  name: "ArticleTiles",
  components: {
    ArticleTile,
  },
  data() {
    return {
      visibleArticleCount: 3,
    };
  },
  props: {
    tiles: {
      required: true,
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(id) {
      this.$emit("buttonClicked", id);
    },
    viewAllArticles() {
      if (this.visibleArticleCount === this.tiles.length) {
        this.visibleArticleCount = 3;
      } else {
        this.visibleArticleCount = this.tiles.length;
      }
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss">
.article-tiles-row {
  max-width: 95dvw;
}
.article-tile-row {
  margin: 0;
  .col {
    padding: 0;
  }

  .article-tile-segment {
    display: flex;
    padding-left: 16px;
    padding-right: 16px;
  }
}

.actions-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  width: 100%;
}
.view-all-articles {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.4px;
  line-height: 20.64px;
  cursor: pointer;
  &:hover {
    color: #50b848;
  }
}
</style>
